var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component, createContext, } from 'react';
import classNames from 'clsx';
import Notification, {} from '../notification';
import { formDataLayerGA4 } from '../../utilities/data-layer';
import { FormContainer, FormHeader, FormSpinner } from './styles/form.styled';
export const FormContext = createContext({
    handlerState: () => { },
    horizontal: false,
    registerComponent: () => { },
    unRegisterComponent: () => { },
    executeSubmit: () => { },
    autocompletion: 'on',
});
class Form extends Component {
    constructor() {
        super(...arguments);
        this.mounted = false;
        this.state = {
            elementsToValidate: 0,
            components: {},
            elementsData: {},
            valid: true,
        };
        this.element = undefined;
        this.handlerState = (elementsData) => {
            const { handlerState } = this.props;
            if (JSON.stringify(elementsData) !== JSON.stringify(this.state.elementsData)) {
                this.setState((prevState) => ({
                    elementsData: Object.assign(Object.assign({}, prevState.elementsData), elementsData),
                }), () => {
                    if (handlerState)
                        handlerState(this.state.elementsData);
                });
            }
        };
        this.executeSubmit = (elementData) => {
            return new Promise((resolve) => {
                this.setState(({ elementsToValidate, elementsData }) => {
                    const counter = elementsToValidate - 1;
                    const elementsDataNew = Object.assign(Object.assign({}, elementsData), elementData);
                    if (counter === 0) {
                        const valid = this.element && this.element.checkValidity();
                        return {
                            elementsData: elementsDataNew,
                            elementsToValidate: 0,
                            valid,
                        };
                    }
                    return { elementsData: elementsDataNew, elementsToValidate: counter };
                }, () => {
                    resolve(true);
                });
            });
        };
        this.finishSubmit = () => {
            const { elementsToValidate, elementsData } = this.state;
            const { onSubmit } = this.props;
            if (elementsToValidate === 0 && onSubmit) {
                onSubmit(Object.assign(Object.assign({}, this.state), { elementsData: this.filterElementsData(elementsData) }));
                const valid = this.element && this.element.checkValidity();
                if (this.props.componentName) {
                    formDataLayerGA4({
                        event: 'user_interaction',
                        type: 'form',
                        component: this.props.componentName,
                        field: '',
                        action: 'submit',
                        actionValue: valid ? 'valid' : `invalid`,
                    });
                }
            }
        };
        this.handleSubmit = (event) => {
            const components = this.state.components;
            const keys = Object.keys(components);
            event.preventDefault();
            if (document.activeElement) {
                document.activeElement.blur();
            }
            this.setState({ elementsToValidate: keys.length }, () => {
                /* eslint-disable */
                (() => __awaiter(this, void 0, void 0, function* () {
                    for (const component of keys) {
                        yield components[component]();
                    }
                    this.finishSubmit();
                }))();
                /* eslint-enable */
            });
        };
        this.registerComponent = ({ reference, validation, }) => {
            this.setState(({ components }) => ({
                components: Object.assign(Object.assign({}, components), { [reference]: validation }),
            }));
        };
        this.unRegisterComponent = (reference) => {
            if (this.mounted) {
                this.setState(({ components }) => {
                    const _a = components, _b = reference, value = _a[_b], nextComponents = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                    return {
                        components: nextComponents,
                    };
                });
            }
        };
        this.filterElementsData = (data) => Object.keys(data).reduce((filteredData, key) => data[key] === undefined
            ? filteredData
            : Object.assign(Object.assign({}, filteredData), { [key]: data[key] }), {});
        this.renderNotification = ({ title, variant, closeButton, onClose, children }) => (_jsx(Notification, { variant: variant, title: title, closeButton: closeButton, onClose: onClose, children: children }));
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const _a = this.props, { loading, children, notification, errorNotification, horizontal, componentName = 'form', handlerState: _, class: className, hideErrorNotification } = _a, props = __rest(_a, ["loading", "children", "notification", "errorNotification", "horizontal", "componentName", "handlerState", "class", "hideErrorNotification"]);
        const { valid } = this.state;
        const isHorizontal = horizontal === true;
        const isLoading = loading === true;
        const classNameGenerate = classNames('PONCHO-form', className, horizontal && 'PONCHO-form--horizontal', loading && 'PONCHO-form--loading');
        return (_jsx(FormContext.Provider, { value: {
                handlerState: this.handlerState,
                horizontal,
                registerComponent: this.registerComponent,
                unRegisterComponent: this.unRegisterComponent,
                executeSubmit: this.executeSubmit,
                autocompletion: this.props.autocompletion || 'on',
            }, children: _jsxs(FormContainer, Object.assign({}, props, { "$isHorizontal": isHorizontal, "$isLoading": isLoading, noValidate: true }, (this.props.autocompletion && {
                autoComplete: this.props.autocompletion,
                autocompletion: undefined, // why? this is not an existing attribute, needs documentation
            }), { className: classNameGenerate, onSubmit: this.handleSubmit, ref: (reference) => {
                    if (reference) {
                        this.element = reference;
                    }
                }, children: [_jsx(FormHeader, { className: "PONCHO-form__header", "aria-live": "assertive", children: notification
                            ? this.renderNotification(notification)
                            : !valid &&
                                !hideErrorNotification &&
                                this.renderNotification(errorNotification || {
                                    title: 'Niet alle velden zijn correct ingevuld',
                                    variant: 'error',
                                }) }), children, isLoading && _jsx(FormSpinner, { message: "Een ogenblik geduld, alstublieft" })] })) }));
    }
}
Form.defaultProps = {
    loading: false,
    handlerState: undefined,
    onSubmit: undefined,
    notification: undefined,
    horizontal: false,
    autocompletion: undefined,
    hideErrorNotification: false,
};
export default Form;
